/* eslint-disable no-unused-vars */
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../assets/css/aunjai-startinfo.css";
import FooterButton from "../../components/ui/Button/FooterButton";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useUser } from "../../hooks/useUser";
import { useLoanStore } from "../../stores/useLoanStore";
import Header from "../Header/HeaderComponent";
import HeaderDesktop from "../Header/HeaderDesktop";

const StartLoanInfo = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("loanProcess");
  const goToFormProfile = () => navigate("/loan-process/form-profile");

  const { is_mou: isMou } = useLoanStore((state) => state.incomeFormProfile);

  const { userData } = useUser();

  const isForeigner = userData?.is_foreigner;

  const isDesktop = useIsDesktop();

  return (
    <>
      <div id="pageStartInfo">
        {isDesktop ? (
          <HeaderDesktop
            title={t("startRegister")}
            showIcon={true}
            onBack={true}
          />
        ) : (
          <Header title={t("startRegister")} showIcon={true} onBack={true} />
        )}
        <div className="wrapContent">
          <div id="pStartInfo">
            <div className="bStartInfo">
              <div className="bContent">
                <div className="bFirstContent ">
                  <div className="bImg">
                    <img src="/assets/img/ci/icon/ico-file-base.svg" />
                  </div>
                  <div className="bTitle">
                    <h2>{t("startRegister2")}</h2>
                    <p>{t("detail")}</p>
                  </div>
                </div>
                <div className="bSecondContent">
                  <div className="bHead">
                    <h3>{t("paper")}</h3>
                  </div>
                  <div className="bList">
                    <div className="bTitle">
                      <h3>{t("paper1")}</h3>
                      {isForeigner ? (
                        <ul>
                          <li>
                            <span>{t("passport")}</span>
                          </li>
                          <li>
                            <span>{t("visa")}</span>
                          </li>
                          <li>
                            <span>{t("workPermit")}</span>
                          </li>
                        </ul>
                      ) : (
                        <ul>
                          <li>
                            <span>{t("identification")}</span> {t("expire")}
                          </li>
                          <li>
                            <span>{t("home")}</span>
                            {t("sig")}
                          </li>
                          <li>
                            <span>{t("incomePaper")}</span>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                  {!isMou && !isForeigner && (
                    <div className="bList">
                      <div className="bTitle">
                        <h3>{t("paper2")}</h3>
                        <ul>
                          <li>
                            <span>{t("identification")}</span> {t("expire")}
                          </li>
                          <li>
                            <span>{t("home")}</span>
                            {t("sig")}
                          </li>
                          <li>
                            <span>{t("slip")}</span>
                            {t("sig")}
                          </li>
                          <li>
                            <span>{t("companyPaper")}</span>
                          </li>
                          <li>
                            <span>{t("finace")}</span>
                            {t("bank")}
                          </li>
                          <li>
                            <span>{t("companyPic")}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterButton onSubmit={goToFormProfile} submitButtonTitle={t("start")} />
    </>
  );
};

export default StartLoanInfo;
